import React, { useEffect } from 'react';
import classNames from 'classnames';
import { HyperLink } from '@src/types/contentful';
import styles from './MobileMenu.module.scss';
import { Maybe } from '@src/graphql/gql-types';
import { useWindow } from '@src/hooks/useWindow';
import MobileNestedMenu from './MobileNestedMenu';

export interface MobileMenu {
  menuLinks: HyperLink[];
  communityNav?: HyperLink[];
  mobileMenuState: {
    open: boolean;
    resetMenu: boolean;
  };
  enquireButtonScrollTo: string;
  handleCloseMobileMenu: (
    event: React.MouseEvent | React.KeyboardEvent
  ) => void;
  headOfficePhoneNumber?: Maybe<string>;
}

const MobileMenu: React.FC<MobileMenu> = ({
  menuLinks,
  communityNav,
  mobileMenuState,
  handleCloseMobileMenu,
  headOfficePhoneNumber,
  enquireButtonScrollTo
}) => {
  const { document } = useWindow();

  useEffect(() => {
    if (document) {
      if (mobileMenuState.open) {
        (
          document.getElementsByTagName('body')[0] as HTMLBodyElement
        ).style.overflow = 'hidden';
      } else {
        (
          document.getElementsByTagName('body')[0] as HTMLBodyElement
        ).style.overflow = 'auto';
      }
    }
  }, [document, mobileMenuState]);

  return (
    <nav
      className={classNames(styles.mobileMenu, {
        [styles.mobileMenuOpen]: mobileMenuState.open
      })}
    >
      <MobileNestedMenu
        openState={mobileMenuState}
        menuLinks={menuLinks}
        communityNav={communityNav}
        handleCloseMobileMenu={handleCloseMobileMenu}
        headOfficePhoneNumber={headOfficePhoneNumber}
        enquireButtonScrollTo={enquireButtonScrollTo}
      />
    </nav>
  );
};

export default MobileMenu;
